/**
 * AWS Amplify Configuration for Cognito Authentication
 * 
 * This file configures AWS Amplify to use our Cognito User Pool
 * for authentication in the DryVox application.
 */

import { Amplify } from 'aws-amplify';

// Amplify configuration for Cognito
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'ap-south-1_6kVjrWhXi',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '7lu79l8jsbmdfja6kluhasv2sq',
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
      },
    },
  },
};

// Initialize Amplify
export function initializeAmplify() {
  Amplify.configure(amplifyConfig);
}

export default amplifyConfig;

